import { useTranslation } from 'react-i18next'

import { useTheme } from 'styled-components'

import { ComboBox, InputWithLabel, Text } from '@reveni-io/reveni-ui'

import * as Styles from './styles'

const InputAndSelect = ({
  label,
  menuItems,
  inputValue,
  inputOnChange,
  selectValue,
  selectOnChange,
  showToggleExpirationSelect,
  onChangeToggleExpirationSelect,
  disabled,
  inputError,
  inputFieldId,
}) => {
  const theme = useTheme()
  const { t } = useTranslation()

  const shouldRenderDurationInputs = () => {
    if (showToggleExpirationSelect && inputValue === null) {
      return false
    }

    return true
  }

  return (
    <Styles.MainContainer>
      <Text type="bodyMBold">{label}</Text>
      <Text type="bodyMRegular">
        {t('El código será válido durante el periodo indicado contando desde la fecha de emisión')}
      </Text>
      {showToggleExpirationSelect && (
        <ComboBox
          label={t('Validez')}
          fullWidth
          menuItems={[
            { label: t('No expira'), value: 'noExpires' },
            { label: t('Expira'), value: 'expires' },
          ]}
          value={inputValue === null ? 'noExpires' : 'expires'}
          handleChange={e => onChangeToggleExpirationSelect(e.target.value)}
          disabled={disabled}
          backgroundColor={theme.colors.background.primary}
        />
      )}
      {shouldRenderDurationInputs() && (
        <Styles.Container>
          <Styles.FieldContainer id={inputFieldId}>
            <InputWithLabel
              label={t('Cantidad')}
              fullWidth
              type="number"
              value={inputValue}
              onChange={inputOnChange}
              disabled={disabled}
              backgroundColor={theme.colors.background.primary}
              error={inputError}
              helperText={inputError ? t('Este campo es obligatorio') : undefined}
            />
          </Styles.FieldContainer>
          <ComboBox
            label={t('Plazo')}
            fullWidth
            menuItems={menuItems}
            value={selectValue}
            handleChange={selectOnChange}
            disabled={disabled}
            backgroundColor={theme.colors.background.primary}
          />
        </Styles.Container>
      )}
    </Styles.MainContainer>
  )
}

export default InputAndSelect
